/**************************************************
 * Nombre:       Home_Actividades
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {theme} from "../../../Tema";
import {NEGRITA} from "../../../Constantes";
import {Splide, SplideSlide} from "@splidejs/react-splide";
import '@splidejs/react-splide/css';
import Tarjeta_Evento from "../../Tarjetas/Tarjeta_Evento";
import uno from '../../../Recursos/tmp_actividad_uno.png'
import dos from '../../../Recursos/tmp_actividad_dos.png'
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";


const Home_Actividades = () => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                backgroundColor: theme.palette.primary.main,
                color: '#fff',
                py: 4

            }}
        >

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3, py: 4}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'center'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                    >

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                            <Typography sx={{
                                fontSize: sCell ? 40 : 48,
                                fontWeight: 600,
                                fontFamily: NEGRITA,
                                lineHeight: 1.2,
                                textAlign: sCell ? 'center' : 'left'
                            }}>Actividades por hacer
                                en Tumaco</Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 8}} sx={{justifyContent: 'flex-start', mt: 1}}>
                            <Typography sx={{fontSize: 16, fontWeight: 400, textAlign: sCell ? 'center' : 'left'}}>
                                En el Hotel Mar Azul, te invitamos a disfrutar de la rica cultura de Tumaco a través de
                                nuestro calendario de eventos y festividades locales, para que vivas una experiencia
                                única durante tu estadía.
                            </Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 8}}>
                            <Splide
                                //ref={refe}
                                aria-label="My Favorite Images" style={{width: '100%'}}
                                options={{
                                    autoplay: true,
                                    speed: 1500,
                                    rewind: true,
                                    perPage: 1,
                                    arrows: true,
                                    perMove: 1,
                                    pagination: true,
                                    width: '100%',
                                    drag: 'free',
                                    snap: true,
                                    interval: 5000,
                                    noDrag: true,
                                    focus: 'center',
                                    type: 'loop',
                                    padding: '0rem',
                                    gap: 20,

                                }}
                            >

                                {items.map((item, index) => {
                                    return (
                                        <SplideSlide key={`qer${index}`}>
                                            <Tarjeta_Evento item={item}/>
                                        </SplideSlide>
                                    )
                                })}


                            </Splide>
                        </Grid>


                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Home_Actividades

const items = [
    {
        img: dos,
        nombre: 'Avistamiento Ballenas',
        descripcion: ' Recorre todo un paraíso inexplorado en El Morro - Tumaco, un lugar donde puedes disfrutar del increíble encuentro con las Ballenas Jorobadas en su temporada del 15 de Julio al 15 de Octubre, a solo 30 minutos mar adentro.',
        fecha: '15 de julio al 15 de ocutubre'
    },
    {
        img: uno,
        nombre: 'Carnaval del Fuego en Tumaco',
        descripcion: '¿Sabías que el carnaval del fuego en Tumaco, nace a raíz de un incendio? Te contamos un poquito de su historia.',
        fecha: '12 al 17 de febrero'
    }
]